import React, { useEffect, useMemo, useState } from "react";
import closeIcon from "../../assets/images/close_icon.png";
import minimizeIcon from "../../assets/images/minimize_icon.png";
import maximizeIcon from "../../assets/images/maximize_icon.png";
import handIcon from "../../assets/images/dwtImages/Hand.png"
import ActionDialog from "../../components/actionDialog";
import { useGetVezoDisclaimerQuery, vezoSessionsApi } from "../../services/vezoService";
// import { useSaveSectionTextMutation } from "app/redux/providerNoteService";
import { cloneDeep } from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import { useGroupChatContext } from "../../context/groupchatContext";
import { usePusherContext } from "../../context/pusherContext";

const VezoCallWindow = () => {

    const [closeCallWindowConfirm, setCloseCallWindowConfirm] = useState(false);
    const [logCallMinutesConfirmation, setLogCallMinutesConfirmation] = useState(false);
    const [isShowCallWindow, setIsShowCallWindow] = useState(false);
    const [callMinimize, setCallMinimize] = useState(false);
    const [logCallDuration, setLogCallDuration] = useState(null);
    const [disclaimer, setDisclaimer] = useState(null);
    const [getVezoSessionsItem] = vezoSessionsApi.endpoints.getVezoSessionsItem.useLazyQuery();
    const [position, setPosition] = useState({ x: 100, y: 50 });
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);


    const groupChatContext = useGroupChatContext();
    const pusherContext = usePusherContext();

    const {selectedChat, vezoCallData, setVezoCallData, telemedPusherData, setTelemedPusherData} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
        vezoCallData: groupChatContext.vezoCallData,
        setVezoCallData: groupChatContext.setVezoCallData,
        telemedPusherData: pusherContext.telemedPusherData,
        setTelemedPusherData: pusherContext.setTelemedPusherData
    }));
    

    // const [saveNoteText, { isLoading: savingNoteText }] = useSaveSectionTextMutation();
    const { data: vezoDisclaimer } = useGetVezoDisclaimerQuery();

    const closeCallWindow = () => {
        setCloseCallWindowConfirm(true);
    }

    const closeCallWindowContinue = () => {
        setCloseCallWindowConfirm(false);
        setVezoCallData(null);
    }

    const resizeCallWindow = () => {
        let tempVezoData = cloneDeep(vezoCallData);
        setCallMinimize(!callMinimize);
    }

    useEffect(() => {
        if (vezoDisclaimer && vezoDisclaimer?.length > 0 && vezoDisclaimer[0]?.TermsCondition && vezoDisclaimer[0]?.TermsCondition.text) {
          setDisclaimer(vezoDisclaimer[0]?.TermsCondition.text);
        }
    }, [vezoDisclaimer]);

    useEffect(() => {
        if(telemedPusherData?.isCloseCallWindow){
            closeCallWindowContinue();
            setTelemedPusherData(null)
        }
        else if(!(telemedPusherData?.visit_key == vezoCallData?.last_call?.visit_key && telemedPusherData?.message?.toString() == 'You have ended the session')){
            let tempVezoData = cloneDeep(vezoCallData);
            getVezoSessionsItem({visit_key: tempVezoData?.last_call?.visit_key}).then((res)=> {
                let session = res?.data;
                if (session?.status=='completed') {
                    toast.warning('This session has ended');
                    closeCallWindowContinue()
                }
                else{
                    setIsShowCallWindow(true)
                }
            });
        }
        else {
            toast.warning('You have ended the session');
            closeCallWindowContinue();
        }
    }, [telemedPusherData?.notificationID]);

    const continueLogCallMinutes = () => {

        setLogCallMinutesConfirmation(false);
            setLogCallDuration(null);
            closeCallWindowContinue();


        let lastCallData = cloneDeep(logCallDuration);
        let note_text = "";
        if (lastCallData?.session?.title) {
            note_text += "*Session:* " + lastCallData?.session?.title + "\n";
        }
        if (lastCallData?.duration) {
            note_text += "*Call duration:* " + lastCallData?.duration + "\n";
            note_text += "*Signed By:* " + selectedChat?.patient?.fname+' '+selectedChat?.patient?.lname + "\n";
        }

        let oldText = selectedChat?.notes?.find((item) => item?.slug == 'telemedicine_call');
        if (oldText) {
            if (oldText?.sections?.length > 0 && oldText?.sections[0]?.note_text) {
                let tempOldText = cloneDeep(oldText?.sections[0]?.note_text).split('Disclaimer:')[0];
                note_text = note_text + "\n" + tempOldText?.trim() + "\n\n" + "*Disclaimer:* " + disclaimer;
            } else {
                note_text += "\n\n" + "*Disclaimer:* " + disclaimer;
            }
        } else {
            note_text += "\n\n" + "*Disclaimer:* " + disclaimer;
        }
        const postData = {
            pid: selectedChat.pid,
            encounter: selectedChat.encounter,
            slug: 'notes',
            notes: [
                {
                    note_text: note_text,
                    title: 'Telemedicine Call',
                    slug: 'telemedicine_call',
                }
            ]
        }
        saveNoteText(postData).then((res) => {
            setLogCallMinutesConfirmation(false);
            setLogCallDuration(null);
            closeCallWindowContinue();
            if (res?.data?.code == 0) {
                toast.success("Telemedicine Call time updated in note successfully.");
            } else {
                toast.error("Failed to update Telemedicine Call time in note.");
            }
        });
    }

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        });
    };
    
    const handleMouseMove = (e) => {
        if(isDragging) {
            setPosition({
                x: e.clientX - offset.x,
                y: Math.max(e.clientY - offset.y, 10) //Ensures that the y position cannot go below 10. Prevents the window from being dragged so far up that the top buttons (like close, minimize, maximize) become hidden off-screen.
            });
        }
    };
    
    const handleMouseUp = () => {
        setIsDragging(false);
    };

    useEffect(() => {
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        } else {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        }

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isDragging]);

    return (
        <>
            <ActionDialog
                onCancelHandler={() => setCloseCallWindowConfirm(false)}
                setShowModal={() => setCloseCallWindowConfirm(false)}
                onConfirmHandler={closeCallWindowContinue}
                showModal={closeCallWindowConfirm}
                title="Are you sure you want to close the call window?"
                confirmButtonText="Yes"
            />

            {/* <ActionDialog
                onCancelHandler={() => {
                    setLogCallMinutesConfirmation(false);
                    setLogCallDuration(null);
                    closeCallWindowContinue();
                }}
                setShowModal={() => {
                    setLogCallMinutesConfirmation(false);
                    setLogCallDuration(null);
                    closeCallWindowContinue();
                }}
                onConfirmHandler={continueLogCallMinutes}
                showModal={logCallMinutesConfirmation}
                title={`Do you want to Add this Telemedicine call time (${logCallDuration?.duration}) in note?`}
                confirmButtonText="Yes"
            /> */}

            {isShowCallWindow ?
                (<div className={`rounded-xl border border-gray-200 p-1 absolute ${callMinimize ? '' : 'bottom-12' }`}
                        style={{ zIndex: 1000, top: position.y, left: position.x, visibility: 'visible',  position: 'fixed' }} 
                    >
                    <img src={closeIcon} className="w-6 h-6 absolute border border-black p-1 top-[-1.5rem] right-[0rem] bg-white cursor-pointer" style={{ zIndex: 1001 }} onClick={closeCallWindow}/>
                    <img src={callMinimize ? maximizeIcon : minimizeIcon} className="w-6 h-6 absolute border border-black p-1 top-[-1.5rem] right-[2rem] bg-white cursor-pointer" style={{ zIndex: 1001 }} onClick={resizeCallWindow}/>
                    <img src={handIcon} className="w-6 h-6 absolute border border-black p-1 top-[-1.5rem] right-[4rem] bg-gray-200 cursor-move" style={{ zIndex: 1001, userSelect: 'none' }}
                        onMouseDown={handleMouseDown}
                        // onMouseLeave={handleMouseUp}
                    />

                    <iframe
                        id="vezoCallSessioniFrame"
                        title="VEZO - Telemedicine"
                        allow="microphone; camera; autoplay; speaker;"
                        src={vezoCallData?.url}
                        style={{ zIndex: 1000 }}
                        height={callMinimize ? "50" : "550"}
                        width="600"
                    ></iframe>
                </div>)
                : null
            }
        </>
    );
};

export default VezoCallWindow;